import type {Sorting} from '../types';

export const mapSortingConfigToString = (sortingConfig: Sorting): string => {
  return `${sortingConfig.field},${sortingConfig.sort}`;
};
